import { useEffect, useState } from "react";

const useHasMounted = () => {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    // Use requestAnimationFrame for smoother initialization
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setHasMounted(true);
      });
    });
  }, []);
  return hasMounted;
};

export default useHasMounted;
